import { AllPostsIcon, DropdownMenu } from '@buffer-mono/popcorn'

import { useMenuItems, useMenuState } from './TypeFilter/useFilterState'

import type { JSX } from 'react'

export function TypeFilterSubMenu(): JSX.Element {
  const [items] = useMenuItems()
  const { selectedItem, setFilterValue } = useMenuState()

  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger>
        <AllPostsIcon /> {selectedItem.title}
      </DropdownMenu.SubTrigger>
      <DropdownMenu.SubMenu>
        <DropdownMenu.RadioGroup
          value={selectedItem.id}
          onChange={(value): void => {
            const item = items.find(({ id }) => id === value)
            if (item) setFilterValue(item.id)
          }}
        >
          {items.map(({ id, title }) => (
            <DropdownMenu.RadioItem key={id} value={id}>
              {title}
            </DropdownMenu.RadioItem>
          ))}
        </DropdownMenu.RadioGroup>
      </DropdownMenu.SubMenu>
    </DropdownMenu.Sub>
  )
}
